import {ButtonBase, Grid, IconButton, Typography} from "@mui/material";
import {Add, DeleteOutline, Remove} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {useFuncionesCarritoLateral} from "./useFuncionesCarritoLateral";


export const useBotonCantidadTarjeta = ({cantidad = 1, producto}) => {
    const [numMaximo, setNumMaximo] = useState(0);
    const [cantidad_, setCantidad] = useState(cantidad)
    const {adicionarCantidadProducto, restarCantidadProducto, quitarProducto} = useFuncionesCarritoLateral()

    const adicionar = (e) => {
        if (e < numMaximo) {
            adicionarCantidadProducto({idProducto: producto.id})
        }
    }
    const restar = (e) => {

        restarCantidadProducto({idProducto: producto.id})

    }

    useEffect(() => {
        setCantidad(cantidad)
    }, [cantidad]);
    useEffect(() => {
        console.log(producto)
        if (producto && producto.numMaximo) {
            setNumMaximo(producto.numMaximo)
        }
    }, [producto]);
    const Boton = ({noBorrar = false}) => {

        return (

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    size={{xs: 10, sm: 9, md: 9}}
                    spacing={1}
                    sx={{border: 1, borderColor: '#00000050', py: 0}}

                >

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                        <IconButton
                            onClick={() => restar(cantidad_)}
                            sx={{
                                borderRadius: 1,
                                p: 0.5
                            }}>

                            <Remove sx={{fill: '#00000080', width: 16, height: 16}}/>

                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{
                            color: '#4d4d4d',
                            borderRadius: 2,
                            fontWeight: 400,
                            fontSize: 14
                        }}>{cantidad_}</Typography>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                        <ButtonBase
                            onClick={() => adicionar(cantidad_)}
                            sx={{borderRadius: 1, p: 0.5}}>
                            <Add sx={{fill: '#00000080', width: 16, height: 16}}/>
                        </ButtonBase>
                    </Grid>


                </Grid>

                {!noBorrar &&
                    <Grid container size={{xs: 2, sm: 3, md: 3}} sx={{justifyContent: 'flex-start',}}>
                        <IconButton
                            onClick={() => quitarProducto(producto)}
                        >
                            <DeleteOutline sx={{fill: 'red'}}/>
                        </IconButton>
                    </Grid>
                }


            </Grid>
        )

    }

    return {

        Boton,
        cantidad
    }
}

